import script from "./DeleteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteDialog.vue?vue&type=script&setup=true&lang=js"

import "./DeleteDialog.vue?vue&type=style&index=0&id=a8374b82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8374b82"]])

export default __exports__